import React, { useState } from "react";

import { BiLogOut } from "react-icons/bi";
import { IoChevronDown } from "react-icons/io5";
import { FaChurch, FaTimes } from "react-icons/fa";

import { useLocation, useNavigate } from "react-router-dom";
import "./Sidebar.scss";

import { useGlobalContext } from "../../context/stateContext";
import NavItem from "./NavItem";
import { financeManagerNavigations, groupLeaderNavigations, navigations, superAdminNavigations, usherNavigations } from "../../utils/SidebarMenus";
import whiteLogo from "../../assets/logos/white-mini.png";

const Sidebar = () => {
  
  const location = useLocation();
  const { user, isSidebarOpen, setIsSidebarOpen } = useGlobalContext();

  const [activeItem, setActiveItem] = useState("/dashboard");
  const navigate = useNavigate();
  const [isFinanceDropdownOpen, setIsFinanceDropdownOpen] = useState(false);


  const logoutuser = () => {
    localStorage.removeItem('selectedGroupId')
    document.cookie = `accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict; Secure`;
    navigate("/");
  };

  const toggleFinanceDropdown = () => {
    setIsFinanceDropdownOpen(!isFinanceDropdownOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  const renderNavigationItem = (navigation, index) => {
    if (navigation.hasDropdown) {
      const isFinanceActive = location.pathname.includes("/finance");

      return (
        <div key={index} className="mx-3">
          <div
            className={`
              group flex items-center justify-between gap-4 px-6 py-3 rounded-xl transition-all duration-200 text-sm font-medium cursor-pointer
              ${
                isFinanceActive
                  ? "bg-white text-blue-700 shadow-lg"
                  : "text-gray-300 hover:bg-white/10 hover:text-white"
              }
            `}
            onClick={toggleFinanceDropdown}
          >
            <div className="flex items-center gap-4">
              <span
                className={`text-lg ${
                  isFinanceActive
                    ? "text-blue-600"
                    : "text-gray-400 group-hover:text-white"
                }`}
              >
                {navigation.icon}
              </span>
              <span className="truncate">{navigation.name}</span>
            </div>
            <span
              className={`transition-transform duration-200 ${
                isFinanceDropdownOpen ? "rotate-180" : ""
              }`}
            >
              <IoChevronDown />
            </span>
          </div>

          <div
            className={`ml-6 mt-2 space-y-1 overflow-hidden transition-all duration-300 ${
              isFinanceDropdownOpen
                ? "max-h-48 opacity-100"
                : "max-h-0 opacity-0"
            }`}
          >
            {navigation.dropdownItems.map((item, itemIndex) => (
              <div
                key={itemIndex}
                className={`
                  block px-6 py-2 rounded-lg transition-all duration-200 text-sm cursor-pointer
                  ${
                    activeItem === item.path
                      ? "bg-blue-50 text-blue-700 font-medium border-l-2 border-blue-500"
                      : "text-gray-400 hover:bg-white/5 hover:text-white"
                  }
                `}
                onClick={() => {
                  setActiveItem(item.path);
                  navigate(item.path);
                }}
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>
      );
    } else {
      return (
        <NavItem
          navigation={navigation}
          index={index}
          key={index}
          isActive={activeItem === navigation.path}
          onClick={() => {
            setActiveItem(navigation.path);
            navigate(navigation.path)
          }}
        />
      );
    }
  };

  const getNavigationItems = () => {
    switch (user?.role) {
      case "Superadmin":
        return superAdminNavigations;
      case "Group Leader":
        return groupLeaderNavigations;
      case "Usher":
        return usherNavigations;
      case "Finance Manager":
      case "Welfare Manager":
        return financeManagerNavigations;
      default:
        return navigations;
    }
  };

  return (
    <div
      className={` text-secondary fixed bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 
        shadow-2xl z-50 transition-transform duration-300 ease-in-out h-screen left-0 pb-20 ${
        isSidebarOpen ? "w-screen md:w-[300px] flex-1" : "hidden flex-0"
      }`}
    >
      {/* Header */}
      <div className="relative bg-gradient-to-r from-blue-600 via-indigo-700 to-purple-800 py-3 px-6">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="relative flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center">
              <img src={whiteLogo} alt="Adom Chapel Logo" className="h-8" />
            </div>
            <div>
              <h1 className="text-white font-bold text-lg">Adom Chapel</h1>
              <p className="text-blue-100 text-xs">Management Portal</p>
            </div>
          </div>
          <button
            onClick={closeSidebar}
            className="lg:hidden p-1 text-white/80 hover:text-white transition-colors"
          >
            <FaTimes className="text-lg" />
          </button>
        </div>
      </div>

      {/* Navigation */}
      <div className="flex-1 py-6 overflow-y-auto">
        <nav className="space-y-2">
          {getNavigationItems().map((navigation, index) =>
            renderNavigationItem(navigation, index)
          )}
        </nav>
      </div>

      <div className="p-4 border-t border-gray-700/50">
        <button
          onClick={logoutuser}
          className="w-full flex items-center gap-4 px-6 py-3 text-gray-300 hover:bg-red-500/10 hover:text-red-400 rounded-xl transition-all duration-200 text-sm font-medium group"
        >
          <BiLogOut className="text-lg group-hover:text-red-400" />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
